export default __webpack_public_path__ + "static/OpenSans-19ba637387f1d6142f551a5dd0b8f40a.ttf";